module.exports = __webpack_public_path__ + "img/u-lyn-batteri-ladeniveau-forside.d3f9089c.svg";